import { Box, styled } from '@mui/system';

export const ButtonContainer = styled(Box)<any>(() => ({
  display: 'flex',
  flexDirection: 'column',
  cursor: 'pointer',
  background: '#F6F6FA',
  border: '1px solid #A8A7CC',

  '.user-info-container': {
    display: 'flex',
    padding: '.75rem',

    p: {
      color: '#52509A',
      fontWeight: 700,
    },

    img: {
      height: '1.25rem',
      marginRight: '.5rem',
    },
  },

  '.image-container': {
    height: '8.75rem',
    overflow: 'hidden',
    position: 'relative',

    '& > img': {
      position: 'absolute',
      height: '100%',
      top: '1.875rem',
      left: '50%',
      transform: 'translate(-50%, 0%)',
    },

    '& > div': {
      position: 'absolute',
      height: '100%',
      top: '1.875rem',
      left: '50%',
      transform: 'translate(-26%, 0%)',
    },
  },

  '.tags-list': {
    display: 'flex',
    gap: '.25rem',
    height: '1.5rem',
  },

  '.info-container': {
    height: '8.75rem',
    padding: '.75rem 1rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',

    '.pressto-title': {
      lineHeight: '21px',
      minHeight: '42px',
    },

    p: {
      color: '#000000',
      fontWeight: '700',
      fontFamily: 'Inter !important',
      lineHeight: '150%',
    },

    '.word-count': {
      color: '#999999',
      fontWeight: 400,
      fontSize: '.75rem',
    },

  },
}));
